module.exports = __webpack_public_path__ + "img/PL08834.95fb990e.png";